import { Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";
import { generalStore } from "../../stores/GeneralStore";
import { CustomCheckbox } from "../ui/CustomCheckbox";
import { t } from "../../i18n/util";

const selectedUserHeaderFieldIdToContent = (id: string, user: string, primaryContactIds: string[], onTogglePrimary: (user: string) => void) => {
    switch (id) {
        case "primary":
            return (
                <div>
                    <CustomCheckbox
                        checked={primaryContactIds.includes(user)}
                        onChange={() => onTogglePrimary(user)}
                    />
                </div>
            );
        case "name":
            return (
                <div>
                    {user}
                </div>
            );
        default:
            return "";
    }
};

type Props = {
    selectedUsers: string[];
    primaryContactIds: string[];
    onTogglePrimary: (user: string) => void;
};

export const SelectedUsersList = observer(({
    selectedUsers,
    primaryContactIds,
    onTogglePrimary,
}: Props) => {
    const loaded = !generalStore.isLoading;

    if (!loaded || selectedUsers.length === 0) return null;

    return (
        <div style={{ width: "100%", maxWidth: "100%" }}>
            <h3 style={{ margin: "16px 0" }}>{t("screen.jobcategory.primaryContact")}</h3>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            style={{
                                width: "5%",
                                fontWeight: "bold",
                                color: THEME.customColors.headingsDark,
                            }}
                        >

                        </TableCell>
                        <TableCell
                            style={{
                                width: "95%",
                                fontWeight: "bold",
                                color: THEME.customColors.headingsDark,

                            }}
                        >
                            {t("screen.personalData.email")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {selectedUsers.map((user) => (
                        <TableRow key={user}>
                            <TableCell
                                style={{
                                    color: THEME.customColors.headingsDark,
                                    paddingLeft: "8px",
                                }}
                            >
                                {selectedUserHeaderFieldIdToContent("primary", user, primaryContactIds, onTogglePrimary)}
                            </TableCell>
                            <TableCell
                                style={{
                                    color: THEME.customColors.headingsDark,
                                }}
                            >
                                {selectedUserHeaderFieldIdToContent("name", user, primaryContactIds, onTogglePrimary)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
});